module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "pre"
    }
  }, [_c('p', {
    staticClass: "ctfm"
  }, [_c('a', {
    attrs: {
      "href": "#/eerbauckham0005#rpre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_vm._v("Some of the material in this book was first presented as lectures that I was invited to give in three institutions in the U.S.: the fourteenth Annual Biblical Studies Lectures, 2003, at Beeson Divinity School, Samford University, Birmingham, Alabama; the Payton Lectures, 2003, at Fuller Theological Seminary, Pasadena, California; and the Derward W. Deere Lectures, 2004, at Golden Gate Baptist Theological Seminary, Mill Valley, California. I am grateful to these institutions for inviting me and to many people, staff and students, who made valuable comments on the lectures and who helped to make my visits a great pleasure.")]), _vm._v(" "), _c('p', [_vm._v("Much of this book was written during a gradual recuperation from prolonged illness. I believe it could not have been written without the prayers of many who supported me during that period, or without — to use Paul’s phrase (2 Cor 12:9) — God’s grace working as power in weakness.")]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ICHARD")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUCKHAM")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e9a1e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eer-bauckham-0007.vue
// module id = 72
// module chunks = 0